
import React, { FunctionComponent, } from 'react';

import {
  Error,
} from '@mui/icons-material';
import {
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import './ErrorMessage.css';

interface Props {
  header?: string,
}

const ErrorMessage: FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'errorMessage' ] );

  return (
    <div className="error-message">
      <Grid container gap={ 2 }>
        <Grid item xs={12}>
          <h2>
            { props.header ? props.header : t( 'error' ) }
            <Error sx={{ color: 'var(--hgs-danger-dark )', fontSize: '1.5em', }}/>
          </h2>
          <span>{ props.children ? props.children : t( 'something-went-wrong' ) }</span>
        </Grid>
      </Grid>
    </div>
  );

}

export default ErrorMessage;
